import React, { useMemo, useState } from 'react';
import { useAuth } from '../../../../contexts/AuthContext';
import { useStudentAssignedTrainings } from '../../../../hooks/useStudentAssignedTrainings';
import type { TrainingItem } from '../../../../types/training';
import { canManageTrainings } from '../../../../utils/permissions';
import { mapStudentTrainingListItemToTrainingItem } from '../../../../utils/studentTrainingList';
import TrainingList from '../../../Training/components/TrainingList';
import TrainingRegisterModal from '../../../Training/TrainingRegister/TrainingRegisterModal';
import styles from './StudentTrainingsStep.module.css';

interface StudentTrainingsStepProps {
  studentId: number;
}

const StudentTrainingsStep: React.FC<StudentTrainingsStepProps> = ({ studentId }) => {
  const { roles } = useAuth();
  const canManage = canManageTrainings(roles);
  const { assignedTrainings, loading, error, refreshAssignedTrainings } = useStudentAssignedTrainings(
    String(studentId),
  );
  const [editingTrainingId, setEditingTrainingId] = useState<string | null>(null);
  const trainings = useMemo(
    () => assignedTrainings.map(mapStudentTrainingListItemToTrainingItem),
    [assignedTrainings],
  );

  const handleOpen = (training: TrainingItem) => {
    setEditingTrainingId(training.id);
  };

  const handleCloseEditor = () => {
    setEditingTrainingId(null);
    refreshAssignedTrainings();
  };

  return (
    <div className={styles.wrap}>
      <TrainingList
        trainings={trainings}
        loading={loading}
        error={error}
        emptyMessage="Nenhum treino atribuído a esta aluna."
        variant="student"
        onOpen={handleOpen}
        showApplyAction={false}
        buildMenuItems={(training) => (canManage
          ? [{ label: 'Editar', onClick: () => handleOpen(training) }]
          : [])}
      />
      <TrainingRegisterModal
        open={Boolean(editingTrainingId)}
        studentId={String(studentId)}
        studentTrainingId={editingTrainingId ?? ''}
        onClose={handleCloseEditor}
      />
    </div>
  );
};

export default StudentTrainingsStep;
